import { Injectable } from "@angular/core";
import { FormInputDialogComponent } from "ng/src/app/shared/form-input-dialog/form-input-dialog.component";
import { FormInputDialogForm } from "ng/src/app/shared/form-input-dialog/form-input-dialog.model";

@Injectable({ providedIn: 'root' })
export class FormInputDialogService {
	private component?: FormInputDialogComponent;
	
	show(form: FormInputDialogForm) {
		this.component?.load(form);
	}
	
	register(component: FormInputDialogComponent) {
		if (this.component && component !== this.component) {
			throw new Error("Attempted to assign new host component to form-input-dialog service instance");
		}
		
		this.component = component;
	}
}

